var map = {
	"./404.svg": "a14a",
	"./DeleteOutlined.svg": "cdbb",
	"./add-lg.svg": "2dbf",
	"./add-task.svg": "b933",
	"./add.svg": "c2a3",
	"./alarm.svg": "3c85",
	"./arrow.svg": "b6e4",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./componentIcon.svg": "a594",
	"./cut.svg": "e2c9",
	"./dashboard.svg": "f782",
	"./device-alarm.svg": "9ebd",
	"./device-done.svg": "e036",
	"./device-lock.svg": "4bed",
	"./device-manual.svg": "b7f9",
	"./device-on.svg": "621b",
	"./device-pause.svg": "bb7e",
	"./device-rerun.svg": "ddb4",
	"./device-run.svg": "4dde",
	"./device-stop.svg": "45d5",
	"./device-unlock.svg": "938d",
	"./device.svg": "2c87",
	"./device_batch.svg": "a018",
	"./device_compose.svg": "7bdb",
	"./device_doing.svg": "3769",
	"./device_done.svg": "c952",
	"./device_todo.svg": "ed3e",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./global-s.svg": "47c3",
	"./global.svg": "90a1",
	"./group.svg": "a75f",
	"./guide.svg": "6683",
	"./icon.svg": "9d91",
	"./in-operation.svg": "f958",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./magnifying-glass.svg": "c9fe",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./qq.svg": "1430",
	"./question.svg": "ae00",
	"./questionMark.svg": "bd7d",
	"./refresh.svg": "b8c4",
	"./scale-add.svg": "1173",
	"./scale-cut.svg": "8655",
	"./search.svg": "8e8d",
	"./setting.svg": "05ff",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./start.svg": "2743",
	"./stop.svg": "bdb7",
	"./swiper-close.svg": "d761",
	"./swiper-left.svg": "3a43",
	"./swiper-right.svg": "6fb6",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./trash.svg": "ce30c",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";